module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qr-code-area"
  }, [(_vm.qrCodeImage) ? _c('div', {
    staticClass: "rotate90degrees qr-code-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.qrCodeImage,
      "alt": _vm.$t('Your QR Code'),
      "title": _vm.$t('Your QR Code')
    }
  })]) : _c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.$t('Sorry, no QR code image found')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4407eb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QRCode.vue
// module id = 318
// module chunks = 1